import { Icon, Binoculars, House, UserCircle, UploadSimple, PaperPlaneTilt } from '@phosphor-icons/react';
import Ghost from 'app/assets/svg/Ghost';

export const OPTIONS: OptionsType = {
  Home: {
    id: 'home',
    icon: House,
  },
  Explore: {
    id: 'explore',
    icon: Binoculars,
  },
  UploadGame: {
    id: 'uploadgame',
    icon: UploadSimple,
  },
  MyProfile: {
    id: 'myprofile',
    icon: UserCircle,
  },
  GameBuilder: {
    id: 'gamebuilder',
    icon: Ghost,
  },
  Chat: {
    id: 'chat',
    icon: PaperPlaneTilt,
  },
};

export type OptionsList = 'Home' | 'Explore' | 'UploadGame' | 'MyProfile' | 'GameBuilder';

type OptionsType = {
  [x in OptionsList]: {
    id: string;
    icon: Icon;
  };
};
